import"./farmer.css";
import React, { useState } from 'react';
import SideMenu from "../components/sidemenu";
import UpMenu from "../components/upmenu";
import { Outlet } from "react-router-dom";
import {FarmerContext} from '../Helper/Context';
// import PageContent from "../components/pagecontent";

function Farmer() {
  const [farmerData, setFarmerData] = useState(false);
  //const {cropid} = useParams(); 
  return (
    <FarmerContext.Provider value={{farmerData, setFarmerData}}>
    <div className="SideMenuAndPageContent">
      <SideMenu  />
        <div className="PageContent UpMenuAndPageContent">
            <UpMenu  /> 
              <div className="PaddingTop" >          
                <Outlet/>    
              </div>        
        </div>
    </div>
    </FarmerContext.Provider>
    );
  }
  export default Farmer;